import { type ChangeEvent, type FormEvent, useState } from 'react';
import './LoginComponent.less';

import { Button } from '@imprivata-cloud/components';
import { Input } from '@imprivata-cloud/design-system';
import type React from 'react';
import { useTranslation } from 'react-i18next';

export type LoginProps = {
  onSubmit: (userEmail: string) => Promise<void>;
  autoComplete?: React.InputHTMLAttributes<HTMLInputElement>['autoComplete'];
};

const LoginComponent = ({ onSubmit, autoComplete }: LoginProps) => {
  const { t } = useTranslation();
  const [userEmail, setUserEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setUserEmail(e.target.value);
  };

  const submitLogin = async (e: FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const trimmedEmail = userEmail.trim();
      await onSubmit(trimmedEmail);
      setUserEmail(trimmedEmail);
    } finally {
      // Keep the button locked to prevent double click
      await new Promise(resolve => setTimeout(resolve, 2_000));
      setIsLoading(false);
    }
  };

  return (
    <div className={'login-form'}>
      <form className={'login-form-items'} onSubmit={submitLogin}>
        <h1 className={'login-form-title'}>{t('tenant-lookup.login.title')}</h1>
        <div className={'login-form-input'}>
          <Input
            data-testid="email-input"
            label={t('tenant-lookup.login.username')}
            autoFocus
            maxLength={150}
            autoComplete={autoComplete}
            value={userEmail}
            onChange={handleChange}
          />
        </div>
        <Button
          type="primary"
          size={'middle'}
          label={t('commons.continue-button')}
          block
          htmlType={'submit'}
          disabled={isLoading || !userEmail.trim()}
        />
      </form>
    </div>
  );
};

export { LoginComponent };
